import { userConstants } from 'Constants/user.constants';
const initialState = { loading: false,errorElement:'' };

export function resetPassword(state = initialState, action={}) {
  switch (action.type) {
    case userConstants.RESET_PASSWORD_REQUEST:
      return { loading: true,errorElement:'' };
    case userConstants.ACTIVATE_PASSWORD_REQUEST:
      return { loading: true,errorElement:'' };
    case userConstants.RESET_PASSWORD_SUCCESS:
    case userConstants.ACTIVATE_PASSWORD_SUCCESS:
      case userConstants.RESET_PASSWORD_FAILURE:
        return { loading: false,errorElement:action.error };
    case userConstants.ACTIVATE_PASSWORD_FAILURE:
      return { loading: false,errorElement:action.error };
    default:
      return state;
  }
}
